import axios from "axios";
import { BASE_PATH } from "../basePath";

const api = axios.create({ baseURL: `${BASE_PATH}/api/v1` });
api.interceptors.request.use((config) => { const token = localStorage.getItem("token"); if (token) config.headers.Authorization = `Bearer ${token}`; return config; });
api.interceptors.response.use((r) => r, (err) => { if (err.response?.status === 401) { localStorage.clear(); window.location.href = `${BASE_PATH}/login`; } return Promise.reject(err); });
export default api;
